import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { forkJoin, map, Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(private http : HttpClient) { 
  }
    get<T>(url: string, headers?: HttpHeaders): Observable<T> {
    return this.http.get<T>(url, { headers });
  }

  post<T>(url: string, body: any, headers?: HttpHeaders): Observable<T> {
    return this.http.post<T>(url, body, { headers });
  }

  put<T>(url: string, body: any, headers?: HttpHeaders): Observable<T> {
    return this.http.put<T>(url, body, { headers });
  }

  delete<T>(url: string, headers?: HttpHeaders): Observable<T> {
    return this.http.delete<T>(url, { headers });
  }
  
  patch<T>(url: string, body: any, headers?: HttpHeaders): Observable<T> {
    return this.http.patch<T>(url, body, { headers });
  }
  paginateApi<T>(url: string, body: any, pageSize = 10000): Observable<T[]> {
    return this.http.post<any>(url, { ...body, limit: pageSize, offset: 0 }).pipe(
      switchMap((response) => {
        const count = response.count ?? 0;
        const rows = response.rows ?? [];
        if (rows.length >= count) {
          return of(rows);
        }
        const tasks: Observable<any>[] = [];
        for (let offset = rows.length; offset < count; offset += pageSize) {
          tasks.push(this.http.post<any>(url, { ...body, limit: pageSize, offset }));
        }
        return forkJoin(tasks).pipe(
          map((results) => {
            const allRows = results.reduce((acc, curr) => acc.concat(curr.rows ?? []), rows);
            return _.unionBy(allRows, 'id');
          })
        );
      })
    );
  }
    postBlob(url: string, body: any, headers?: HttpHeaders): Observable<any> {
    return this.http.post(url, body, { 
      headers,
      responseType: 'blob',
      observe: 'response'
    });
  }
}
